import React, { useCallback, useEffect, useState } from "react";
import { Breadcrumb, Col, Form, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import Graybg from "../../../UI/Graybg";
import Card from "../../../UI/Card/Card";
import Input from "../../../UI/Input/Input";
import Select from "../../../UI/Select/Select";
import SecBTN from "../../../UI/SecBTN";
import classes from "./AddUser.module.css";
import ConfirmationModal from "../../../UI/ConfirmationModal/ConfirmationModal";
import SuccessModal from "../../../UI/SuccessModal/SuccessModal";
import userService from "../../../app/services/user.service";
import Loader from "../../../UI/loader/loader";
//import MultiSelect from "../../../UI/MultiSelect/MultiSelect";
import { toast, ToastContainer, Zoom } from "react-toastify";
import MultiSelectDropdown from "../../../UI/MultiSelectDropdown/MultiSelectDropdown";
import Switch from "react-switch";
import Toast from "../../../UI/Toast/Toast";

const AddUser = () => {
  //MODAL STATES
  const [showPopUp1, setShowPopUp1] = useState(false);
  const [showPopUp2, setShowPopUp2] = useState(false);
  //loader
  const [loading, setLoading] = useState(false);
  //user data state
  const data = {
    user_name: "",
    name: "",
    email: "",
    mobile: "",
    active: "0",
    profile_id: "",
    center_id: "",
    team_lead_id: "",
    password: "",
    cnf_password: "",
    subject:[]
  };
  const [userData, setUserData] = useState(data);
  const [profileList, setProfileList] = useState([]);
  const [centerList, setCenterList] = useState([]);
  const [teamInfoList, setTeamInfoList] = useState([]);
  const [subjectList, setSubjectList] = useState([]);
  const [checked, setChecked] = useState(userData.active==='1');
  //const [selectedOption, setSelectedOption] = useState(null);
  const onHideHandler = () => {
    setShowPopUp1(false);
    setShowPopUp2(false);
  };
  useEffect(() => {
    try {
      setLoading(true);
      userService
        .getProfileList()
        .then((data) => setProfileList(data.data.data));
      userService.getCenterList().then((data) => setCenterList(data.data.data));
      userService
        .getTeamInfoList()
        .then((data) => setTeamInfoList(data.data.data));
      userService
        .getSubjectList()
        .then((data) => setSubjectList(data.data.data))
        .then(() => setLoading(false));
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  }, []);
  // const onActivateUser = (e) => {
  //   if (e.target.checked) {
  //     setUserData((prev) => {
  //       return { ...prev, active: 1 };
  //     });
  //   } else {
  //     setUserData((prev) => {
  //       return { ...prev, active: 0 };
  //     });
  //   }
  // };
  const handleSwitch = nextChecked => {
    setChecked(nextChecked);
    if(nextChecked){
      setUserData((prev) => {
          return { ...prev, active: 1 };
           });
    }else{
      setUserData((prev) => {
           return { ...prev, active: 0 };
         });
    }
  };
  const onMultiSelect = (selectedList) => {
    setUserData(prev => {
      return {
        ...prev,
        subject:selectedList
      }
    })
  }
  const onMultiRemove = (selectedList) => {
    setUserData(prev => {
      return {
        ...prev,
        subject:selectedList
      }
    })
  }
  const submitHandler = (e) => {
    e.preventDefault();
    setShowPopUp1(true);
  };
  const yesHandler = useCallback(() => {
    setShowPopUp1(false);
    const x = JSON.parse(localStorage.getItem("user"));
    // if (userData.mobile.length !== 10) {
    //   toast.error("Enter 10 digit mobile number");
    //   return;
    // }
    // if (userData.name !== 0) {
    //   toast.error("Enter name");
    //   return;
    // }
    let body = {
      user_name: userData.user_name,
      name: userData.name,
      mobile: userData.mobile,
      pswd: userData.password,
      //cnf_password: userData.cnf_password,
      email: userData.email,
      profile_id: userData.profile_id,
      center_id: userData.center_id,
      team_lead: userData.team_lead_id,
      active: userData.active,
      updated_by: x?.data?.user?.user_id,
      details: userData.subject,
    };
    console.log(body);
    if (userData.password !== userData.cnf_password) {
      toast.error("Password doesn't match !!");
      return;
    }
    setLoading(true);
    userService
      .createUser(body)
      .then((res) => {
        setLoading(false);
        console.log(res)
        if(res.data === 0){
          toast.error(res.message);
          return;
        }
        setUserData(data);
        setShowPopUp2(true);
      })
      .catch((error) => {
        setLoading(false);
        if (error.response) {
          //console.log(error.response);
          toast.error(error.response.data.message);
          //console.log("server responded");
        } else if (error.request) {
          toast.error("network error");
        } else {
          //console.log(error);
          toast.error(error);
        }
      });
  }, [
    data,
    userData.active,
    userData.center_id,
    userData.cnf_password,
    userData.email,
    userData.mobile,
    userData.name,
    userData.password,
    userData.profile_id,
    userData.team_lead_id,
    userData.user_name,
    userData.subject
  ]);
  return (
    <div className="section">
      {loading && <Loader />}
      <ConfirmationModal
        title={`Are you sure you want to Create User?`}
        show={showPopUp1}
        onHide={onHideHandler}
        yesHandler={yesHandler}
        confirmTxt="yes"
      />
      <SuccessModal
        show={showPopUp2}
        onHide={onHideHandler}
        title={`User Created Successfully!`}
        btnTxt="Ok"
      />
      <Toast />
      <h4>User's List</h4>
      <Breadcrumb>
        <Breadcrumb.Item>
          <Link to="/userList">User's List</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item active>Add User</Breadcrumb.Item>
      </Breadcrumb>
      <Graybg>
        <h6 className="mb-2">Edit User Details</h6>
        <Card>
          <form onSubmit={submitHandler}>
            <Row className="g-3 mb-3">
              <Col className="pe-lg-4" lg={6} md={6} sm={12}>
                <label>Name :</label>
                <Input
                  required
                  placeholder="Enter Name"
                  name="name"
                  value={userData.name}
                  onChange={(e) => {
                    setUserData((prev) => {
                      return {
                        ...prev,
                        name: e.target.value,
                      };
                    });
                  }}
                />
              </Col>
              <Col className="pe-lg-4" lg={6} md={6} sm={12}>
                <label>Email :</label>
                <Input
                  required
                  type="email"
                  placeholder="Enter Email"
                  name="email"
                  value={userData.email}
                  onChange={(e) => {
                    setUserData((prev) => {
                      return {
                        ...prev,
                        email: e.target.value,
                      };
                    });
                  }}
                />
              </Col>
              <Col className="pe-lg-4" lg={6} md={6} sm={12}>
                <label>Mobile No.:</label>
                <Input
                  required
                  placeholder="Enter Mobile No."
                  name="mobile"
                  type="number"
                  value={userData.mobile}
                  onChange={(e) => {
                    if (e.target.value.length > 10) {
                      return false;
                    }
                    setUserData((prev) => {
                      return {
                        ...prev,
                        mobile: e.target.value,
                      };
                    });
                  }}
                />
              </Col>
              <Col className="pe-lg-4" lg={6} md={6} sm={12}>
                <label>Profile :</label>
                <Select
                  required
                  value={userData.profile_id}
                  name="profile_id"
                  onChange={(e) => {
                    setUserData((prev) => {
                      return {
                        ...prev,
                        profile_id: e.target.value,
                      };
                    });
                  }}
                >
                  <option value="" disabled>
                    Select Profile
                  </option>
                  {profileList.map((data) => (
                    <option key={data.profile_id} value={data.profile_id}>
                      {data.profile_name}
                    </option>
                  ))}
                </Select>
              </Col>
              <Col className="pe-lg-4" lg={6} md={6} sm={12}>
                <label>Center :</label>
                <Select
                  value={userData.center_id}
                  required
                  name="center_id"
                  onChange={(e) => {
                    setUserData((prev) => {
                      return {
                        ...prev,
                        center_id: e.target.value,
                      };
                    });
                  }}
                >
                  <option value="" disabled>
                    Select Center
                  </option>
                  {centerList.map((data) => (
                    <option key={data.center_id} value={data.center_id}>
                      {data.center}
                    </option>
                  ))}
                </Select>
              </Col>
              <Col className="pe-lg-4" lg={6} md={6} sm={12}>
                <label>Username :</label>
                <Input
                  placeholder="Enter Username"
                  name="user_name"
                  required
                  value={userData.user_name}
                  onChange={(e) => {
                    setUserData((prev) => {
                      return {
                        ...prev,
                        user_name: e.target.value,
                      };
                    });
                  }}
                />
              </Col>
              <Col className="pe-lg-4" lg={6} md={6} sm={12}>
                <label>Password :</label>
                <Input
                  placeholder="Enter Password"
                  required
                  type="password"
                  value={userData.password}
                  onChange={(e) => {
                    setUserData((prev) => {
                      return {
                        ...prev,
                        password: e.target.value,
                      };
                    });
                  }}
                />
              </Col>
              <Col className="pe-lg-4" lg={6} md={6} sm={12}>
                <label>Confirm password :</label>
                <Input
                  placeholder="Enter password again to confirm"
                  type="password"
                  required
                  name="cnfrm_password"
                  value={userData.cnf_password}
                  //onFocus={setPswd(true)}
                  onChange={(e) => {
                    setUserData((prev) => {
                      return {
                        ...prev,
                        cnf_password: e.target.value,
                      };
                    });
                  }}
                />
              </Col>
              <Col className="pe-lg-4" lg={6} md={6} sm={12}>
                <label>Team Lead :</label>
                <Select
                  value={userData.team_lead_id}
                  name="team_lead"
                  required
                  onChange={(e) => {
                    setUserData((prev) => {
                      return {
                        ...prev,
                        team_lead_id: e.target.value,
                      };
                    });
                  }}
                >
                  {" "}
                  {/* need to get the id of the team lead to the member */}
                  <option value="" disabled>
                    Select Team Lead
                  </option>
                  {teamInfoList.map((data) => (
                    <option key={data.user_id} value={data.user_id}>
                      {data.name}
                    </option>
                  ))}
                </Select>
              </Col>
              <Col className="pe-lg-4" lg={6} md={6} sm={12}>
                <label>Subjects :</label>
                <MultiSelectDropdown
                  options={subjectList}
                  displayValue="sub_name"
                  onSelect={onMultiSelect}
                  onRemove={onMultiRemove}
                />
              </Col>
            </Row>
            <div className="d-flex align-items-center">
              <label htmlFor="custom-switch" className="me-2">
                Activate this User
              </label>
              <Switch
                onChange={handleSwitch}
                checked={checked}
                className="react-switch"
              />
            </div>
            <div className="my-5 text-center">
              <SecBTN type="submit" className={classes["sec-btn"]}>
                Create User
              </SecBTN>
            </div>
          </form>
        </Card>
      </Graybg>
    </div>
  );
};

export default AddUser;
